<template>
 <div style=" padding:20px;margin-top:10px;background: #fff;  " >
 <el-table v-loading="loading"
    :data="tableData" 
	border 
    style="width: 100%"
    height="500">
    <el-table-column
      prop="id"
      label="id" 
	  v-if="id==0" 
      width="1%">
    </el-table-column>
    <el-table-column
      fixed
      prop="invoice_date"
      label="日期"
      min-width="10%">
    </el-table-column>
    <el-table-column
      prop="company_name"
      label="发票抬头"
      min-width="20%">
    </el-table-column>
    <el-table-column
      prop="company_taxId"
      label="税号"
      min-width="10%">
    </el-table-column>
    <el-table-column
      prop="shipName"
      label="收件人"
      min-width="10%">
    </el-table-column>
    <el-table-column
      prop="shipTel"
      label="收件人电话"
      min-width="10%">
    </el-table-column>	
	<el-table-column
      prop="shipAddress"
      label="收件人地址"
      min-width="20%">
    </el-table-column>	
	
    <el-table-column 
      label="操作"
      min-width="10%">
	  	 <template slot-scope="scope">
			 <el-button type="primary" size="small"  v-if="scope.row.invoice_state == 1" @click="handleRowView(scope.$index, scope.row)">查看明细</el-button>
		 </template>
    </el-table-column>
  </el-table>
  <div style="margin-top:10px; display: flex; align-items:right;text-align: right ">
  <el-pagination @current-change="handlePageChange" :current-page="page" :page-size="10" layout="total, prev, pager, next, jumper" :total="total">
				</el-pagination> </div>
  </div>
</template>
 
<script>
export default {
    data() {
      return {
	  	page: 1,
		id: 1,
		total: 0,
		size:10,
	    is_loading: false,
		loading: true,
        tableData: [],
      }
    },
    props: {
        titleSync: String,
      },
	  
    methods: {
		handlePageChange(val) {
			this.page = val;
			//保存到localStorage
			localStorage.setItem('adPage', this.page)
			localStorage.setItem('adFilterForm', JSON.stringify(this.filterForm));
			this.getList()
		},
		handleRowView(index, row) {
          this.routerTo();
          /*
				this.axios.post('https://www.myferp.com/admin/user/invoiceInfo', { id: row.id }).then((response) => {
					console.log(response.data)
					if (response.data.errno === 0) {
						this.$message({
							type: 'success',
							message: '删除成功!'
						});

						this.getList();
					}
				})
          */
 
		},
	  getInfo(){
 
	    let that = this;
	    let userInfo = localStorage.getItem('userInfo');
		let info = JSON.parse(userInfo);
		let id = info.id;
        console.log( userInfo);  
		  $.ajax({
              type: "GET",
			  data:  {id: info.id, page: 1, size: 10},
              url: "https://www.myferp.com/admin/user/invoiceInfo",
              dataType: "json",  //返回类型为 json
              beforeSend: function (request) {
                request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
                },   
              error: function(XMLHttpRequest, textStatus, errorThrown) { 
 		          that.loading = false;
			      Vue.prototype.$message({
                    message: data,
                    type: 'error'
                    });
                        return false;
                    },             
              success: function (data) {
		        
				console.log(JSON.stringify(data));
				that.tableData = data.data.data ; 
				that.page = data.data.currentPage;
                that.total = data.data.count;
                that.loading = false;				
                }
              });	
	  },
	  routerTo(){
	    this.$emit('update:titleSync', 'info')
	  
	  },
      onSubmit() { 
			 
			     
      }
    },
    mounted() {
	  this.getInfo();
	},
    computed: {
        config: {
          get() {
            return this.titleSync
          },
          set(val) {
            this.$emit('update:titleSync', val)
          }
         }
      },	
  }
</script>
 
 


// WEBPACK FOOTER //
// src/components/setting/invoice.vue